<template>
  <header id="facetHeader" :class="tripfinderViewModel.backgroundColorFilter + ' pt-3 px-3 pb-5 mt-5 text-center'">
    <h2 class="h3 mb-2">Her er dit søgeresultat</h2>
    <p
      class="mb-4 tripfinder-result-text"
      v-if="
        tripfinderViewModel.paging.items.length === 1 &&
        tripfinderViewModel.paging.items[0].documentType === 'PageCruise'
      "
    >
      {{ item.totalNumberOfResults }} {{ singlePlural(item) }}
    </p>
    <p class="mb-4 tripfinder-result-text" v-else>
      <template
        v-for="(item, index) in tripfinderViewModel.paging.items"
        :key="index"
      >
        <span v-if="item.totalNumberOfResults > 0 && item.documentType !== 'PageCruise'">
          {{ item.totalNumberOfResults }} {{ singlePlural(item) }}
        </span>
      </template>
    </p>
    <button
      id="tripfinderFacetsHeading"
      class="btn collapsed"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#tripfinderFacets"
      aria-expanded="true"
      aria-controls="tripfinderFacets"
      @mousedown="preventFocus"
    >
      søgemuligheder
    </button>
  </header>
  <div
    id="tripfinderFacets"
    class="accordion-collapse collapse"
    aria-labelledby="tripfinderFacetsHeading"
  >
    <div class="facet-search-bar mx-auto">
      <div id="tripfinderFacetSearchLarge" class="d-flex flex-wrap">
        <div
          class="btn-group facet-dropdown m-3"
          v-for="(filter, index) in tripfinderViewModel.filter.filters"
          :key="index"
        >
          <button
            class="btn btn-lg facet-dropdown__button"
            type="button"
            data-bs-toggle="dropdown"
            data-bs-auto-close="outside"
            data-bs-reference="parent"
            aria-expanded="false"
            @mousedown="preventFocus"
          >
            <span class="facet-dropdown__button-label">{{ filter.title }}</span>
            <span class="icon-accordion_caret_down ms-2"></span>
            <span class="bar"></span>
          </button>
          <div class="p-1 dropdown-menu">
            <ul class="list-unstyled">
              <facet-dropdown-list-item
                v-for="(tag, index) in filter.tags"
                :key="index"
                :tag="tag"
                :cssBackground="'bg__white-light'"
              />
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
      <div class="d-flex facet-search-bar mx-auto flex-wrap mt-1 px-2">
        <button
          type="button"
          class="btn btn-tag"
          v-for="tag in selectedFilters"
          :key="tag.id"
          :title="['Fjern ' + tag.name]"
          @mousedown="preventFocus"
          @click="selectItem(tag)"
        >
          {{ tag.name }} <span class="ps-1">X</span>
        </button>
      </div>
      <span id="facetCheck"></span>
</template>
<script>
import FacetDropdownListItem from "./FacetDropdownListItem.vue";
export default {
  name: "FacetSearchBarLarge",
  props: [],
  components: {
    FacetDropdownListItem,
  },
  computed: {
    tripfinderViewModel() {
      return this.$store.state.tripfinderViewModel;
    },
    selectedFilters() {
      return this.$store.state.tripfinderSelectedFilters;
    },
  },
  methods: {
    // TODO: Place in store?
    singlePlural: function (pageItem) {
      if (pageItem.documentType === "PageTravel")
        return pageItem.totalNumberOfResults === 1 ? "rejse" : "rejser";

      if (pageItem.documentType === "PageHotel")
        return pageItem.totalNumberOfResults === 1 ? "hotel" : "hoteller";

      if (pageItem.documentType === "PageExperience")
        return pageItem.totalNumberOfResults === 1 ? "oplevelse" : "oplevelser";

      if (pageItem.documentType === "PageCruise")
        return pageItem.totalNumberOfResults === 1
          ? "krydstogt"
          : "krydstogter";
    },
    selectItem: function (tag) {
      this.$store.dispatch("selectItem", tag.id);
    },
    preventFocus: function (event) {
      // Prevents focus styling on click
      event.preventDefault();
    },
  },
};
</script>